module.exports = __webpack_public_path__ + "img/couponfornewcouple.8156774e.png";